import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {
  ACCREDITATION_STATUS_ACCEPTED,
  ACCREDITATION_STATUS_EXPIRED,
  ACCREDITATION_STATUS_HOLD,
  ACCREDITATION_STATUS_OPEN,
  ACCREDITATION_STATUS_REJECTED,
} from '../../config'

import CSVExporterFactory from '../../managers/csv_export/csv_exporter_factory'
import { formatSnakeCaseToSpaceCase } from '../../utils/formatters'
import { Toolbar, ToolbarItem } from '../common/toolbar/toolbar'
import CSVExport from '../csv_export'

const statusesArray = [
  ACCREDITATION_STATUS_OPEN,
  ACCREDITATION_STATUS_HOLD,
  ACCREDITATION_STATUS_EXPIRED,
  ACCREDITATION_STATUS_REJECTED,
  ACCREDITATION_STATUS_ACCEPTED,
].sort()
const statuses = {
  All: null,
}
const csvExportHeader = ['Code', 'Active', 'Children', 'Parent', 'Created', 'Updated']

statusesArray.forEach((i) => (statuses[formatSnakeCaseToSpaceCase(i)] = i))

class AccreditationSearchBar extends PureComponent {
  handleChange = (e) => {
    const filter = { ...this.props.filter, search: e.target.value }
    this.props.updateFilter(filter)
  }

  handleSearchSubmit = (e) => {
    e.preventDefault()
    const { filter } = this.props
    this.props.updateFilter(filter)
    this.props.onSearch(filter)
  }

  handleSearchReset = (e) => {
    const filter = {
      search: '',
      status: null,
    }
    this.props.updateFilter(filter)
    this.props.onReset()
  }

  handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchSubmit(e)
    }
  }

  render() {
    const { props } = this
    const { count, requestUrl } = props
    return (
      <Toolbar columns={3}>
        <ToolbarItem className={'input-group'} style={{ minWidth: 400 }}>
          <input
            onKeyPress={this.handleEnterKeyPress}
            className='form-control'
            placeholder='First Name/Last Name/Transaction ID'
            value={props.filter.search}
            onChange={this.handleChange}
          />
          <button className='btn btn-default' type='button' onClick={this.handleSearchSubmit}>
            Search
          </button>
          <button className='btn btn-default' type='button' onClick={this.handleSearchReset}>
            Reset
          </button>
        </ToolbarItem>
        <ToolbarItem className={'input-group'}>
          <select
            value={props.filter.status}
            className='form-control'
            onChange={({ target }) => {
              const filter = { ...props.filter, status: target.value }
              props.updateFilter(filter)
              props.onSearch(filter)
            }}
          >
            {Object.entries(statuses).map(([status, value], i) => (
              <option key={i} value={value}>
                {status}
              </option>
            ))}
          </select>
        </ToolbarItem>
        <ToolbarItem className={'input-group'} style={{ flex: 1, paddingRight: 5 }} last={true}>
          <CSVExport
            exporter={CSVExporterFactory.ACCREDITATION_STATUSES}
            header={csvExportHeader}
            count={count}
            url={requestUrl}
          />
        </ToolbarItem>
      </Toolbar>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccreditationSearchBar))
